import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, createSearchParams } from 'react-router-dom';
import GlobalError from '../components/GlobalError';
import { Typography } from '@mui/material';
import ProductList from '../components/ProductList';
import Pagination from '../components/Pagination';
import axiosInstance from '../utils/axiosInstance';

const ProductsPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // データ状態
  const [dataset, setDataset] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // URL から検索クエリを作る
  const getQuery = () => ({
    product_name: searchParams.get('product_name') || '',
    category_id: searchParams.get('category_id') || '',
  });

  // データ取得関数
  const fetchData = async (page = 1, query = {}) => {
    setError(null);

    try {
      // まずログインユーザー用
      const privateResponse = await axiosInstance.get(
        '/product/user',
        {
          params: {
            page,
            ...query
          },
          withCredentials: true
        }
      );

      setDataset(privateResponse.data.data || []);
      setCurrentPage(privateResponse.data.currentPage || page);
      setTotalPages(privateResponse.data.totalPages || 1);

    } catch (error) {

      // 未ログインなら公開APIへ
      if (error.response?.status === 401) {
        try {
          const publicResponse = await axiosInstance.get(
            '/product',
            {
              params: {
                page,
                ...query
              }
            }
          );

          setDataset(publicResponse.data.data || []);
          setCurrentPage(publicResponse.data.currentPage || page);
          setTotalPages(publicResponse.data.totalPages || 1);

        } catch (err) {
          setError(
            err.response?.data?.message ||
            err.message ||
            'データ取得に失敗しました'
          );

          setDataset([]);
        }

      } else {
        setError(
          error.response?.data?.message ||
          error.message ||
          'データ取得に失敗しました'
        );

        setDataset([]);
      }
    }
  };

  // URL変更時
  useEffect(() => {
    fetchData(1, getQuery());
  }, [searchParams]);

  // ページクリック時
  const handlePageClick = (page) => {
    const query = getQuery();
    fetchData(page, query);
    navigate({
      pathname: '/products',
      search: `?${createSearchParams({ ...query, page })}`
    });
  };
  if (error) return <GlobalError errorMessage={error} />;
  return (
    <>
      {dataset.length > 0 ? (
        <ProductList products={dataset} />
      ) : (
        <Typography>該当する商品はありません</Typography>
      )}

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageClick}
        />
      )}
    </>
  );
};

export default ProductsPage;
